<!-- Header -->
<div class="header">
  <div class="container">
    <div class="header-logo">
      <h3 class="uppercase letter-spacing-1">
        <a routerLink="/">Maximo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Creative Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Corporate Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Marketing Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Freelancer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Designer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">Startup Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-one">Portfolio One</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two">Portfolio Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three">Portfolio Three</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/" class="link-social-facebook"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/" class="link-social-twitter"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/" class="link-social-instagram"><i class="bi bi-instagram"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Hero section -->
<div class="section-fullscreen bg-image parallax" style="background-image: url('assets/images/slides/slide-1.jpg')">
    <div class="bg-dark-06">
        <div class="container text-center">
            <div class="position-middle">
                <h1 class="display-4 fw-semi-bold">We Build Digital Experiences<br> That Matter</h1>
            </div>
            <!-- smoothscroll button -->
            <div class="position-bottom">
                <a class="button-circle button-circle-lg button-circle-white-2 icon-lg" (click)="scrollToSection('about')">
                    <i class="bi bi-arrow-down"></i>
                </a>
            </div>
        </div><!-- end container -->
    </div>
</div>
<!-- end Hero section -->

<!-- About section -->
<div id="about" class="section">
    <div class="container">
        <div class="mb-5 text-center">
            <h2 class="fw-normal display-6">Designing <span class="text-highlight-gradient">the Future</span> of Creativity</h2>
        </div>
        <div class="row g-4 g-lg-5">
            <div class="col-12 col-md-4">
                <p>We imagine, design, and build digital stories that elevate your brand beyond the ordinary. Ut enim ad
                    minim veniam,
                    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat</p>
            </div>
            <div class="col-12 col-md-4">
                <p>We transform ideas into bold visuals, helping businesses tell their story with clarity and
                    creativity.Ut enim ad minim veniam,
                    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat</p>
            </div>
            <div class="col-12 col-md-4">
                <div *ngFor="let skill of skills">
                    <div class="progress-box">
                        <h6 class="fw-medium">{{ skill.name }}</h6>
                        <div class="animated-progress">
                            <div [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"><span>{{ skill.level }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end About section -->

<!-- Image Slider -->
<div class="section pt-0">
    <div class="container">
        <owl-carousel-o [options]="aboutCarousel" class="owl-btn-center-lr img-slider">
            <ng-template carouselSlide *ngFor="let about of aboutImgs">
                <div class="bg-overlay-gradient">
                    <img src="assets/images/slides/{{about.img}}" alt="{{about.alt}}">
                </div>
            </ng-template>
        </owl-carousel-o>
    </div><!-- end container -->
</div>
<!-- end Image Slider -->

<!-- Facts section -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/main-bg-3.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center">
            <div class="row g-4">
                <!-- Counter box 1 -->
                <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3">
                    <h1 class="fw-thin display-5 counter">{{fact.displayedNumber | number:'1.0-0'}}</h1>
                    <h5 class="fw-light">{{fact.title}}</h5>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Facts section -->

<!-- Portfolio section -->
<div class="section">
    <div class="container">
        <!-- Portfolio filter -->
        <div class="filter filter-style-3 mb-5 text-center">
            <ul>
                <li *ngFor="let filter of portfolioFilters" [class.active]="selectedFilter === filter" (click)="filterPortfolio(filter)">
                    {{filter}}
                </li>
            </ul>
        </div>
        <!-- end Portfolio filter -->
        <div class="row portfolio-grid g-2 hover-style-1">
            <!-- Portfolio box -->
            <div *ngFor="let item of portfolioItems; let i = index" [ngClass]="{'col-12 col-md-6 col-lg-4 portfolio-item': true, 'hidden': !isPortfolioVisible(item)}" [attr.data-category]="item.categories.join(' ')">
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img [src]="item.img" [alt]="item.alt">
                    </div>
                    <a routerLink="/portfolio-one"></a>
                    <div class="portfolio-title">
                        <div>
                            <h4 class="fw-medium">{{item.title}}</h4>
                            <span>{{formatCategories(item.categories) | titlecase}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end row/portfolio-grid-->
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Testimonial section -->
<div class="section border-top">
    <div class="container">
        <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
          <ng-template carouselSlide *ngFor="let slide of slideStore">
            <!-- Testimonial box -->
            <div class="testimonial-box">
              <img class="mb-3" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
              <h5 class="fw-normal line-height-140 m-0">{{slide.title}}</h5>
              <span class="font-small fw-normal">{{slide.subtitle}}</span>
              <p class="mt-3">{{slide.desc}}</p>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div><!-- end container -->
<!-- end Testimonial section -->

<!-- Play video section -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-05">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-6">
                    <h1 class="fw-thin display-5 line-height-150 m-0">Designing the Future, <span class="text-highlight-gradient">One Idea</span> at a Time.</h1>
                </div>
                <div class="col-12 col-md-6 text-md-end">
                    <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple mt-3 icon-xl lightbox-media-link" (click)="openPopup()"><i class="bi bi-play"></i></a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Play video section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Services section -->
<div class="section">
    <div class="container text-center">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="fw-normal display-6">Helping <span class="text-highlight-gradient">Startups Stand</span> Out</h2>
                </div>
            </div>
        </div>
        <div class="row icon-5xl g-4">
            <!-- Icon text box -->
            <div *ngFor="let service of services" class="col-12 col-md-4">
                <i [class]="'bi ' + service.icon + ' text-dark'"></i>
                <h5 class="fw-normal mt-2">{{service.title}}</h5>
                <p>{{service.desc}}</p>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Blog section -->
<div class="section border-top">
    <div class="container">
        <div class="mb-5">
            <div class="row align-items-end">
                <div class="col-12 col-sm-6">
                    <h2 class="fw-normal display-6">Our <span class="text-highlight-gradient">Trending</span> Posts</h2>
                </div>
                <div class="col-12 col-sm-6 text-sm-end">
                    <a class="button-text-1" routerLink="/blog-grid">Read All Posts</a>
                </div>
            </div>
        </div>
        <owl-carousel-o [options]="blogCarousel" class="owl-btn-center-lr blog-slider">
            <ng-template carouselSlide *ngFor="let blog of blogs">
                <div>
                    <div class="hoverbox-6">
                        <a routerLink="/blog-grid">
                            <img [src]="blog.img" [alt]="blog.title">
                            <div class="content top bg-dark">
                                <span class="font-small fw-normal uppercase m-0 text-white">{{blog.category}}</span>
                            </div>
                        </a>
                    </div>
                    <div class="p-3">
                        <h4 class="fw-normal mb-1"><a routerLink="/blog-grid">{{blog.title}}</a></h4>
                        <span>{{blog.date}}</span>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div><!-- end container -->
</div>
<!-- end Blog section -->

<!-- Clients section -->
<div class="section bg-dark-lightest">
    <div class="container">
        <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr brands-carousel">
            <ng-template carouselSlide *ngFor="let brand of brandStore">
                <div class="client-box">
                    <a href="#."><img src="assets/images/brands/{{brand.img}}" alt="brand-img"></a>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Contact section -->
<div class="section">
    <div class="container">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <h2 class="fw-normal display-6">Get <span class="text-highlight-gradient">In</span> Touch</h2>
                </div>
            </div>
        </div>
        <div class="row g-4">
            <!-- Contact Info -->
            <div class="col-12 col-md-4">
                <div class="mb-4">
                    <h6 class="fw-semi-bold m-0">Phone:</h6>
                    <p>+(1) 234 567 89</p>
                </div>
                <div class="mb-4">
                    <h6 class="fw-semi-bold m-0">Email:</h6>
                    <p>yoursite&#64;domain.com</p>
                </div>
                <div>
                    <h6 class="fw-semi-bold m-0">Address:</h6>
                    <p>Patton Street Caulfield East VIC 3145</p>
                </div>
            </div>
            <!-- Contact Form -->
            <div class="col-12 col-md-8">
                <div class="contact-form text-start">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input border-radius" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                </div>
            </div>
            <!-- end Contact Form -->
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->
